import { AppRoute } from '@app-types/appRoute'
import { authorizationGuard, RouteData, RouteWithData } from './app.routes.guard'
const PATHS = AppRoute.PATHS

export const routes: RouteWithData[] = [
    {
        path: '',
        redirectTo: `/${PATHS.purchasingCoOp}`,
        pathMatch: 'full'
    },
    {
        path: PATHS.purchasingCoOp,
        children: [
            {
                path: '',
                redirectTo: PATHS.orders,
                pathMatch: 'full'
            },
            {
                path: PATHS.contracts,
                canActivateChild: [authorizationGuard],
                data: { roles: ['GlobalAdmin'] },
                children: [
                    {
                        path: '',
                        redirectTo: PATHS.contractList,
                        pathMatch: 'full'
                    },
                    {
                        path: PATHS.contractList,
                        loadComponent: () => import('./features/purchasingCoOp/contracts/contractList/contractList.component').then(m => m.ContractListComponent)
                    },
                    {
                        path: PATHS.newContract,
                        loadComponent: () => import('./features/purchasingCoOp/contracts/contract/newContract.component').then(m => m.NewContractComponent)
                    },
                    {
                        path: PATHS.contract + '/:id',
                        loadComponent: () => import('./features/purchasingCoOp/contracts/contract/contract.component').then(m => m.ContractComponent)
                    },
                ]
            },
            {
                path: PATHS.orders,
                children: [
                    {
                        path: '',
                        redirectTo: PATHS.orderList,
                        pathMatch: 'full'
                    },
                    {
                        path: PATHS.orderList,
                        loadComponent: () => import('./features/purchasingCoOp/orders/orderList/orderList.component').then(m => m.OrderListComponent)
                    },
                    {
                        path: PATHS.order + '/:id',
                        loadComponent: () => import('./features/purchasingCoOp/orders/order/order.component').then(m => m.OrderComponent)
                    },
                    {
                        path: PATHS.order,
                        canActivate: [authorizationGuard],
                        data: { roles: ['Member'] },
                        loadComponent: () => import('./features/purchasingCoOp/orders/order/newOrder.component').then(m => m.NewOrderComponent)
                    },
                ]
            },
            {
                path: PATHS.reports,
                children: [
                    {
                        path: PATHS.vehicleReport,
                        canActivate: [authorizationGuard],
                        data: { roles: ['GlobalAdmin'] },
                        loadComponent: () => import('./features/purchasingCoOp/reports/vehicleReport/vehicleReport.component').then(m => m.VehicleReportComponent)
                    },
                    {
                        path: PATHS.pendingPayments,
                        canActivate: [authorizationGuard],
                        data: { roles: ['GlobalAdmin'] },
                        loadComponent: () => import('./features/purchasingCoOp/reports/pendingPaymentsReport/pendingPaymentsReport.component').then(m => m.PendingPaymentsReportComponent)
                    },
                    {
                        path: PATHS.sellerVehicles,
                        canActivate: [authorizationGuard],
                        data: { roles: ['Seller', 'GlobalAdmin'] },
                        loadComponent: () => import('./features/purchasingCoOp/reports/sellerVehiclesReport/sellerVehiclesReport.component').then(m => m.SellerVehiclesReportComponent)
                    },
                    {
                        path: PATHS.vehicleLimitAdjustments,
                        canActivate: [authorizationGuard],
                        data: { roles: ['Member'] },
                        loadComponent: () => import('./features/purchasingCoOp/reports/vehicleLimitAdjustmentsReport/vehicleLimitAdjustmentsReport.component').then(m => m.VehicleLimitAdjustmentsReportComponent)
                    },
                ]
            },
            {
                path: PATHS.vehicles,
                canActivateChild: [authorizationGuard],
                data: { roles: ['GlobalAdmin'] },
                children: [
                    {
                        path: '',
                        redirectTo: PATHS.vehicleTypeList,
                        pathMatch: 'full'
                    },
                    {
                        path: PATHS.vehicleTypeList,
                        loadComponent: () => import('./features/purchasingCoOp/vehicles/vehicleTypeList/vehicleTypeList.component').then(m => m.VehicleTypeListComponent)
                    },
                    {
                        path: PATHS.vehicleClassList,
                        loadComponent: () => import('./features/purchasingCoOp/vehicles/vehicleClassList/vehicleClassList.component').then(m => m.VehicleClassListComponent)
                    },
                ]
            },
        ]
    },
    {
        path: PATHS.membership,
        canActivateChild: [authorizationGuard],
        data: { roles: ['GlobalAdmin'] },
        children: [
            {
                path: '',
                redirectTo: PATHS.organizations,
                pathMatch: 'full'
            },
            {
                path: PATHS.organizations,
                children: [
                    {
                        path: '',
                        redirectTo: PATHS.organizationsList,
                        pathMatch: 'full'
                    },
                    {
                        path: PATHS.organizationsList,
                        loadComponent: () => import('./features/membership/organizations/organizationsList/organizationList.component').then(m => m.OrganizationsListComponent)
                    },
                    {
                        path: PATHS.newOrganization,
                        loadComponent: () => import('./features/membership/organizations/organization/newOrganization.component').then(m => m.NewOrganizationComponent)
                    },
                    {
                        path: PATHS.organization + '/:id',
                        loadComponent: () => import('./features/membership/organizations/organization/organization.component').then(m => m.OrganizationComponent)
                    }
                ]
            },
            {
                path: PATHS.users,
                children: [
                    {
                        path: '',
                        redirectTo: PATHS.usersList,
                        pathMatch: 'full'
                    },
                    {
                        path: PATHS.usersList,
                        loadComponent: () => import('./features/membership/users/userList/userList.component').then(m => m.UserListComponent)
                    },
                    {
                        path: PATHS.user + '/:id',
                        loadComponent: () => import('./features/membership/users/user/user.component').then(m => m.UserComponent)
                    },
                    {
                        path: PATHS.deniedUsers,
                        loadComponent: () => import('./features/membership/deniedUsers/deniedUserList.component').then(m => m.DeniedUserListComponent)
                    }
                ]
            },
        ]
    },
    {
        path: PATHS.accessRevoked,
        loadComponent: () => import('./features/accessRevoked/accessRevoked.component').then(m => m.AccessRevokedComponent)
    }
]